import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M12 0a12 12 0 00-4.21 23.23V20.9A10 10 0 012 11.84a1.58 1.58 0 013.16 0 6.84 6.84 0 0013.68 0 1.58 1.58 0 113.16 0 10 10 0 01-5.79 9.06v2.33A12 12 0 0012 0zm0 17.11a4.22 4.22 0 114.21-4.22A4.21 4.21 0 0112 17.11z" /><path d="M11.42 10.66a.66.66 0 00-1 .57v3.33a.66.66 0 001 .57l2.88-1.66a.67.67 0 000-1.15z" /></svg>);